import React from "react";
import { Checkbox, FormControlLabel, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import { ProductSubTypes } from "../../models/Service";
import { useSelectedServiceSubType } from "../../hooks/useSelectedServceSubTypes";

function ServiceSubTypeSelect(): React.ReactNode {
  const { selectedSubTypes, setSelectedSubTypes } = useSelectedServiceSubType();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleSubType = (subType: string) => {
    setSelectedSubTypes(
      selectedSubTypes.includes(subType)
        ? selectedSubTypes.filter((item) => item !== subType)
        : [...selectedSubTypes, subType]
    );
  };

  return (
    <>
      <Tooltip title="Filter Sub type" arrow>
        <IconButton
          onClick={handleClick}
          sx={{
            width: 32,
            height: 32,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1
          }}
        >
          {selectedSubTypes.length ? <FilterAltIcon /> : <FilterAltOffIcon />}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {ProductSubTypes.map((item) => (
          <MenuItem key={item} disableRipple onClick={(e) => e.stopPropagation()} sx={{ py: 0 }}>
            <FormControlLabel
              label={item}
              control={
                <Checkbox
                  checked={selectedSubTypes.includes(item)}
                  onChange={() => toggleSubType(item)}
                  sx={{ ml: "4px" }}
                />
              }
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ServiceSubTypeSelect;
